import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import FormBuilderIndex from './FormBuilder/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/forms'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'forms_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'forms_settings_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'forms_settings_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: ':formId/edit',
          name: 'forms_settings_edit',
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
          component: FormBuilderIndex,
        },
      ],
    },
  ],
};
